export default __webpack_public_path__ + "static/media/user-2.44afbad9.svg";